import { useSpring, animated, useSprings } from '@react-spring/web';
// import { cubicBezier } from 'react-native-redash'; // or any cubicBezier implementation you like
import { bezier } from '../utilities/bezier-utils'
import { CubicBounceLerp } from '../types/bounce-types';
import { displayBounceDurationDefault } from '../assets/constants';

type useSpringObj = {
    width: number,
    config: {
        duration: number,
        easing: (x: number) => number
    }
}

const buildSprings = (values: CubicBounceLerp[], width: number): useSpringObj[] => {
    let halfBounces = []
    for (let i = 0; i < values.length; i++) {
        let duration = (values[i].dstLerpX - values[i].ognLerpX) / 2 * displayBounceDurationDefault
        let xRange = width / 2
        let inEase = bezier(1 - values[i].ognXCubic, 1 - values[i].ognYCubic, values[i].peakXCubic, values[i].peakYCubic)
        let outEase = bezier(1 - values[i].peakXCubic, 1 - values[i].peakYCubic, values[i].ognXCubic, values[i].ognYCubic)
        let inBounce: useSpringObj = {
            width: values[i].peakLerpY * xRange,
            config: { duration: duration, easing: inEase }
        }
        let outBounce: useSpringObj = {
            width: 0,
            config: { duration: duration, easing: outEase, }
 
        }
        halfBounces.push(inBounce)
        halfBounces.push(outBounce)
    }
    return halfBounces
}

//@ts-ignore
export const BouncePreview = ({ bounceValues, width, height }) => {
    const builtSprings = buildSprings(bounceValues, width)
    //@ts-ignore
    const springs = useSpring({
        from: { background: '#007bff', y: 0, x: 0 },
        to: builtSprings,
      }) 
  
    return (
        <div>    
         <animated.div
        //@ts-ignore
          style={{
          height: '4px',
          borderRadius: 0,
          marginTop: '6px',
        //   marginTop: '1vh',
          ...springs,
            }}
        />
 
      </div>
    );
  }